module.exports = __webpack_public_path__ + "static/media/fundcorp.86a1434a.svg";